import React from 'react';

// Types
import { ReviewState } from 'Shared/types/Review.type';

// Hooks
import { useReview } from 'Shared/utils/hooks/use-review';

// Helpers
import * as ReviewsHelpers from 'Shared/model_helpers/Reviews.helper';
import * as ReviewFormHelpers from 'Shared/model_helpers/ReviewForm.helper';

// Components
import WpProgressBar from 'Wpds/components/progress/WpProgressBar';

type Props = {
  review;
};

const ReviewProgressBar = ({ review }: Props) => {
  const slug = ReviewsHelpers.getSlug(review) as string;

  const { state, isShared, isCompleted, mergedReviewForms: allPeerReviewForms } = useReview({
    slug,
  });

  const completedReveiewForms = allPeerReviewForms.filter(reviewForm =>
    Boolean(ReviewFormHelpers.getSubmittedAt(reviewForm))
  );

  const percent = (completedReveiewForms.size / allPeerReviewForms.size) * 100;
  let renderPercent = percent === 0 ? 10 : percent;
  if (state === ReviewState.COMPILATION_COMPLETED_BUT_NOT_SHARED || isShared || isCompleted) {
    renderPercent = 100;
  }

  const baseClassName = 'ReviewProgressBar';
  return (
    <div className={baseClassName}>
      <WpProgressBar percent={renderPercent} color="purple" />
    </div>
  );
};

export default ReviewProgressBar;
